export class ContratosEntity {
    constructor(
        public NumeroContrato?: string,
        public Descripcion?: string,
        public NombreContratista?: string,
        public Estado?: string,
        public CodigoEstado?: number,
        public InicioVigencia?: Date,
        public FinVigencia?: Date,
        public SeguroObligatorio?: string,
        public Cobertura?: string,
        public FechaExpiracion?: Date,
        public EstadoSeguro?: number,
        public Observaciones?: string,
        public EliminacionContrato?: number,
        public ValorContrato?: number,
        public DiasMora?: number,
        public NumeroPoliza?: string,
        public CodigoContrato?: number,
        public Codigounidad?: number
    ) {

    }
}

export class ContratistaEntity {
    constructor(
        public CodigoContratista?: number,
        public CliCod?: number,
        public CiuCod?: number,
        public UniCod?: number,
        public RucContratista?: string,
        public NombreContratista?: string,
        public DireccionContratista?: string,
        public TelefonoContratista?: string,
        public CelularContratista?: string,
        public Contacto1?: string,
        public CargoCont1?: string,
        public EmailCont1?: string,
        public Contacto2?: string,
        public CargoCont2?: string,
        public EmailCont2?: string,
        public EstadoContratista?: number,
        public RegCod ?: number
    ) {

    }
}
export class ContratosExcel {
    constructor(
        public Contratos?: ContratosEntity[],
        public NombreContratista?: string,
        public CodigoCliente?: number
    ) {

    }
}
export class BuscaContratista {
    constructor(
        public RucContratista?: string,
        public CiuCod?: number
    ) {

    }
}










// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/contratistas_entity.ts